<div class="search-container">
	<!-- Dashboard Date Range Filtering Section -->
	<div class="date-range-section">
		<div class="date-range-row">
			<div class="date-field">
				<label for="start-date">Start {{ showTimeSelection() ? 'date & time' : 'date' }}</label>
				<p-datepicker
					inputId="start-date"
					[(ngModel)]="startDate"
					[dateFormat]="'yy-mm-dd'"
					[showTime]="false"
					[showIcon]="true"
					[showWeek]="true"
					[placeholder]="'YYYY-MM-DD'"
					appendTo="body"
					(onSelect)="clearActivePreset()"
					data-testid="search-start-date-select"
				/>

				@if (showTimeSelection()) {
					<div class="time-inputs">
						<div class="time-input-wrapper">
							<button type="button" class="time-arrow time-arrow-up" (click)="incrementStartHour()" data-testid="search-start-hour-increment-button">
								<i class="pi pi-chevron-up"></i>
							</button>
							<input
								pInputText
								id="start-hour"
								type="number"
								min="0"
								max="23"
								maxlength="2"
								[value]="startHour()"
								(keydown)="onTimeInputKeyDown($event)"
								(input)="onStartHourChange($any($event.target).value)"
								(blur)="onStartHourBlur($event)"
								class="time-input"
								placeholder="HH"
								data-testid="search-start-hour-input"
							/>
							<button type="button" class="time-arrow time-arrow-down" (click)="decrementStartHour()" data-testid="search-start-hour-decrement-button">
								<i class="pi pi-chevron-down"></i>
							</button>
						</div>
						<span class="time-separator">:</span>
						<div class="time-input-wrapper">
							<button type="button" class="time-arrow time-arrow-up" (click)="incrementStartMinute()" data-testid="search-start-minute-increment-button">
								<i class="pi pi-chevron-up"></i>
							</button>
							<input
								pInputText
								id="start-minute"
								type="number"
								min="0"
								max="59"
								maxlength="2"
								[value]="startMinute()"
								(keydown)="onTimeInputKeyDown($event)"
								(input)="onStartMinuteChange($any($event.target).value)"
								(blur)="onStartMinuteBlur($event)"
								class="time-input"
								placeholder="MM"
								data-testid="search-start-minute-input"
							/>
							<button type="button" class="time-arrow time-arrow-down" (click)="decrementStartMinute()" data-testid="search-start-minute-decrement-button">
								<i class="pi pi-chevron-down"></i>
							</button>
						</div>
					</div>
				}
			</div>

			<div class="date-field">
				<label for="end-date">End {{ showTimeSelection() ? 'date & time' : 'date' }}</label>
				<p-datepicker
					inputId="end-date"
					[(ngModel)]="endDate"
					[dateFormat]="'yy-mm-dd'"
					[showTime]="false"
					[showIcon]="true"
					[showWeek]="true"
					[placeholder]="'YYYY-MM-DD'"
					appendTo="body"
					(onSelect)="clearActivePreset()"
					data-testid="search-end-date-select"
				/>

				@if (showTimeSelection()) {
					<div class="time-inputs">
						<div class="time-input-wrapper">
							<button type="button" class="time-arrow time-arrow-up" (click)="incrementEndHour()" data-testid="search-end-hour-increment-button">
								<i class="pi pi-chevron-up"></i>
							</button>
							<input
								pInputText
								id="end-hour"
								type="number"
								min="0"
								max="23"
								maxlength="2"
								[value]="endHour()"
								(keydown)="onTimeInputKeyDown($event)"
								(input)="onEndHourChange($any($event.target).value)"
								(blur)="onEndHourBlur($event)"
								class="time-input"
								placeholder="HH"
								data-testid="search-end-hour-input"
							/>
							<button type="button" class="time-arrow time-arrow-down" (click)="decrementEndHour()" data-testid="search-end-hour-decrement-button">
								<i class="pi pi-chevron-down"></i>
							</button>
						</div>
						<span class="time-separator">:</span>
						<div class="time-input-wrapper">
							<button type="button" class="time-arrow time-arrow-up" (click)="incrementEndMinute()" data-testid="search-end-minute-increment-button">
								<i class="pi pi-chevron-up"></i>
							</button>
							<input
								pInputText
								id="end-minute"
								type="number"
								min="0"
								max="59"
								maxlength="2"
								[value]="endMinute()"
								(keydown)="onTimeInputKeyDown($event)"
								(input)="onEndMinuteChange($any($event.target).value)"
								(blur)="onEndMinuteBlur($event)"
								class="time-input"
								placeholder="MM"
								data-testid="search-end-minute-input"
							/>
							<button type="button" class="time-arrow time-arrow-down" (click)="decrementEndMinute()" data-testid="search-end-minute-decrement-button">
								<i class="pi pi-chevron-down"></i>
							</button>
						</div>
					</div>
				}
			</div>
		</div>

		<!-- Quick Filter Buttons -->
		<div class="date-filter-buttons">
			<p-button
				label="1 Day"
				(onClick)="setOneDayRange()"
				[text]="true"
				size="small"
				class="filter-button"
				[styleClass]="activePreset() === '1d' ? 'filter-button-active' : ''"
				data-testid="search-preset-1d-button"
			/>
			<p-button
				label="1 Week"
				(onClick)="setOneWeekRange()"
				[text]="true"
				size="small"
				class="filter-button"
				[styleClass]="activePreset() === '1w' ? 'filter-button-active' : ''"
				data-testid="search-preset-1w-button"
			/>
			<p-button
				label="2 Weeks"
				(onClick)="setTwoWeeksRange()"
				[text]="true"
				size="small"
				class="filter-button"
				[styleClass]="activePreset() === '2w' ? 'filter-button-active' : ''"
				data-testid="search-preset-2w-button"
			/>
			@if (!showMonthFilter()) {
				<p-button
					label="1 Month"
					(onClick)="setOneMonthRange()"
					[text]="true"
					size="small"
					class="filter-button"
					[styleClass]="activePreset() === '1m' ? 'filter-button-active' : ''"
					data-testid="search-preset-1m-button"
				/>
				<p-button
					label="3 Months"
					(onClick)="setThreeMonthsRange()"
					[text]="true"
					size="small"
					class="filter-button"
					[styleClass]="activePreset() === '3m' ? 'filter-button-active' : ''"
					data-testid="search-preset-3m-button"
				/>
			}
		</div>
	</div>
</div>
